import * as React from "react";
import { getBackgroundColorClass } from "../colors/index.mjs";
import { Container } from "../container/container.mjs";
import { HeaderContext } from "../helpers/header-provider/header-provider.mjs";
import debounce from "debounce";
import "tabbable";
import { Languages } from "../languages/languages.mjs";
import { Logo } from "../logo/telia/logo.mjs";
import { SkipLinks } from "../skip-links/skip-links.mjs";
const MiniHeader = (props) => {
  var _a;
  const { languages, logo, className, theme, background } = props;
  const { setHeaderHeight: setHeaderHeightInContext } = React.useContext(HeaderContext);
  const element = React.useRef(null);
  React.useEffect(() => {
    function setHeaderHeight() {
      if (element.current) {
        setHeaderHeightInContext(element.current.clientHeight);
      }
    }
    const debouncedResizeHandler = debounce(setHeaderHeight, 100);
    setHeaderHeight();
    window.addEventListener("resize", debouncedResizeHandler);
    return () => {
      window.removeEventListener("resize", debouncedResizeHandler);
      debouncedResizeHandler.clear();
    };
  }, [setHeaderHeightInContext]);
  const backgroundColor = React.useMemo(() => {
    if (background) {
      return background;
    }
    if (theme === "dark") {
      return "neutral-bg-level-1";
    }
  }, [background, theme]);
  function BEM() {
    const classArray = ["mini-header"];
    if (!logo && languages) {
      classArray.push("mini-header--no-logo");
    }
    if (backgroundColor) {
      classArray.push(getBackgroundColorClass(backgroundColor));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  }
  return /* @__PURE__ */ React.createElement("header", { className: BEM(), ref: element, "data-theme": theme }, props.skipLinks && props.skipLinks.length > 0 && /* @__PURE__ */ React.createElement(SkipLinks, { links: props.skipLinks }), (logo || languages) && /* @__PURE__ */ React.createElement(Container, { className: "mini-header__inner" }, logo && /* @__PURE__ */ React.createElement(Logo, { size: "small", ...logo, theme: (_a = logo == null ? void 0 : logo.theme) != null ? _a : theme }), languages && /* @__PURE__ */ React.createElement(Languages, { languages, theme })));
};
export {
  MiniHeader
};
